simply.relatedHeightInit = function() {
	var relate_prod_title_par = '#related_product .rel-list .rel-title';
  var relate_prod_title_child = '#related_product .rel-list .rel-title span';
	simply.miniHeight(relate_prod_title_par,relate_prod_title_child);
};
$(document).ready(function() {
	$('#related_product .rel-list').slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:'<div class="tw-cursor-pointer tw-leading-[0] tw-py-[7px] tw-pl-[8px] tw-pr-[6px] tw-py-3 tw-rounded-full tw-border-2 tw-border-solid tw-border-[#A45C2A] tw-group hover:tw-bg-[#A45C2A] tw-absolute tw-top-[50%] xl:-tw-left-10 -tw-translate-y-1/2 max-xl:tw-left-[-50px]"><span class="tw-relative tw-inline-block before:tw-inline-block before:tw-h-[7px] before:tw-w-[7px] before:tw-border-b-0 before:tw-border-r-0 before:tw-border-t-2 before:tw-border-l-2 before:tw-border-solid before:tw-border-t-[#A45C2A] before:tw-border-l-[#A45C2A] group-hover:before:tw-border-l-white group-hover:before:tw-border-t-white before:-tw-rotate-45"></span></div>',
    nextArrow:'<div class="tw-cursor-pointer tw-leading-[0] tw-py-[7px] tw-pl-[6px] tw-pr-[8px] tw-py-3 tw-rounded-full tw-border-2 tw-border-solid tw-border-[#A45C2A] tw-group hover:tw-bg-[#A45C2A] tw-absolute tw-top-[50%] xl:-tw-right-10 -tw-translate-y-1/2 max-xl:tw-right-[-50px]"><span class="tw-relative tw-inline-block before:tw-inline-block before:tw-h-[7px] before:tw-w-[7px] before:tw-border-b-0 before:tw-border-r-0 before:tw-border-t-2 before:tw-border-l-2 before:tw-border-solid before:tw-border-t-[#A45C2A] before:tw-border-l-[#A45C2A] group-hover:before:tw-border-l-white group-hover:before:tw-border-t-white before:tw-rotate-[135deg]"></span></div>',
    responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows:false,
      }
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
      }
    }
    ]
  });
	simply.relatedHeightInit();
	$(window).resize(function(){
    setTimeout(function(){
  	  simply.relatedHeightInit();
    },300);
	});
});